import { Component, OnInit } from '@angular/core';
import { Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';

import { CBMError, FcdProvider, Task } from 'app/models';
import { NcisBasemapType } from 'app/models/enums';
import { DownloadService, FcdProviderService, HttpService, MstToNcisService, TaskService } from 'app/services';
import { ExportTaskBase } from 'app/shared/export/exportTaskBase';
import { enumValues } from 'app/shared/util/enumValues';

@Component({
  selector: 'app-admin-fcdtoncis',
  templateUrl: './fcdtoncis.component.html',
  styleUrls: ['./fcdtoncis.component.scss']
})
export class FcdtoNcisComponent extends ExportTaskBase implements OnInit {
  public isAcquiringNcisFcdMstTaskStatus = true;
  public isAcquiringBasemapTaskStatus = true;
  public fcdProviders: FcdProvider[];
  public isSendingBasemap = false;
  public errorMessagesFcd: CBMError[];
  public errorMessagesBasemap: CBMError[];
  public ncisBasemapType: NcisBasemapType;
  public taskIsRunning = false;

  public basemapTask: Task;
  public fcdTask: Task;

  public ncisBasemapTypes: string[];

  constructor(
    private readonly fcdProviderService: FcdProviderService,
    private readonly mstToNcisService: MstToNcisService,
    private readonly taskService: TaskService,
    httpService: HttpService,
    downloadService: DownloadService
  ) {
    super(httpService, downloadService);
  }

  protected createSendToNcisTask() {
    this.taskIsRunning = true;
    this.errorMessages = [];

    const mstToNcisTask: Observable<Response> = this.mstToNcisService.createTaskSendFcdToNcis(
      this.fcdProviders[0].ncisContractId
    );

    this.handleTaskAsync(mstToNcisTask);
  }

  protected onTaskFinished(task: Task) {
    this.taskIsRunning = false;
  }

  protected onTaskCheckError() {
    this.taskIsRunning = false;
  }

  ngOnInit() {
    this.ncisBasemapTypes = enumValues(NcisBasemapType);

    this.fcdProviderService.getFcdProviders().subscribe(
      (providers: FcdProvider[]) => {
        this.fcdProviders = providers ? providers : [];
      },
      errors => console.log(errors)
    );

    this.taskService.getTaskByType('NcisSendFcdMstTask').subscribe(value => {
      this.fcdTask = value;

      if (this.fcdTask.status === 'running') {
        this.taskIsRunning = true;
        this.waitForTask(this.taskService.getTaskUrl(this.fcdTask.id));
      }
      this.isAcquiringNcisFcdMstTaskStatus = false;
    });
    this.taskService.getTaskByType('NcisSendBasemapTask').subscribe(value => {
      this.basemapTask = value;

      if (this.basemapTask.status === 'running') {
        this.taskIsRunning = true;
        this.waitForTask(this.taskService.getTaskUrl(this.basemapTask.id));
      }
      this.isAcquiringBasemapTaskStatus = false;
    });
  }

  public sendBasemapToNcis(): void {
    this.isSendingBasemap = true;
    this.errorMessagesBasemap = [];

    this.mstToNcisService.sendBasemapToNcis(this.ncisBasemapType).subscribe(
      () => {
        this.isSendingBasemap = false;
      },
      (errors: CBMError[]) => {
        this.errorMessagesBasemap = errors;
        this.isSendingBasemap = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/export/fcdtoncis/fcdtoncis.component.ts